// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requiredProductRowStyles } from "@steiner/App/Components/ProductDetails/RequiredProductRow";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

requiredProductRowStyles.unitOfMeasure = {
    weight: fontConfig.weight.bold,
};

requiredProductRowStyles.price = {
    priceLabelText: {
        css: css`
            display: none;
        `,
    },
};

requiredProductRowStyles.productTitle = {
    typographyProps: {
        ellipsis: true,
        css: css`
            max-width: 400px;
            ${xScreen("lte",1300)} {
                max-width: 200px;
            }
            ${xScreen("lte","md")} {
                max-width: none;
            }
        `,
    },
    css: css`
        &&& {
            margin-left: 0;
        }
    `,
};

requiredProductRowStyles.wrapperLink = {
    css: css`
        &&& {
            margin-left: 0;
        }
    `,
}